import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-note-with-icon',
  templateUrl: './note-with-icon.component.html',
  styleUrls: ['./note-with-icon.component.scss']
})
export class NoteWithIconComponent implements OnInit {

  // declarations 
  @Input() fontSizeResponsive?: string = "fs-14"
  @Input() fontSizeDesktop?: string = "fs-lg-16"
  @Input() fontColor?: string = "text-eand-primary-100"
  @Input() fontweight?: string = "fw-normal"
  @Input() iconSizeDesktop?: string = "eand-wh-24"
  @Input() iconSizeResponsive?: string = "eand-wh-24"
  @Input() backgroundColor?: string = "bg-eand-primary-100"
  @Input() paddingBlock?: string = "py-16"
  @Input() paddingInline?: string 
  @Input() iconName?: string 
  @Input() roundedClass?: string
  @Input() noteText: string
  @Input() reverseDirection?: boolean = false
  @Input() clickHereEnabled: boolean = false;
  @Input() additionalNote?: string;
  @Input() isFreePasses?: boolean = false;
  @Output() triggerScrollToPasses: EventEmitter<any> = new EventEmitter();
  // declarations 

  constructor() { }

  ngOnInit(): void {
  }
  scrollToContentPasses(){
    this.triggerScrollToPasses.emit();
  }

}
